import { router } from "@/plugins/router";
import { cookies } from "@/plugins/vueCookies";
import { getField, updateField } from "vuex-map-fields";
import { apiUserLogin } from "@/plugins/api.js";
import swal from "sweetalert2";

const namespaced = true;
const defaultState = () => ({
  loginData: {
    service_account: "",
    user_account: "",
    user_password: "",
    remember: false,
  },
});
const state = defaultState();
const mutations = {
  updateField,
  resetState: () => Object.assign(state, defaultState()),
  setUserInfo: (state, userObject) =>
    Object.assign(state.loginData, userObject),
  };
  // console.log("state.loginData",state.loginData)
  // console.log("userObject",userObject)
const actions = {
  initUserInfo: ({ commit }) => {
    if (localStorage.rem) {
      commit("setUserInfo", {
        service_account: localStorage.sa,
        user_account: localStorage.ua,
        remember: true,
      });
    }
  },
  login: async () => {
    const { data } = await apiUserLogin(state.loginData);
    if (data.response.status === "passed") {
      // cookie 到期日為當日11:59:59
      const today = new Date(+new Date() + 8 * 60 * 60 * 1000)
        .toISOString()
        .substr(0, 10); //GMT+0800 台北標準時間
      const midnight = new Date(`${today}T23:59:59`);
      localStorage.setItem("sa", state.loginData.service_account);
      localStorage.setItem("ua", state.loginData.user_account);
      // 是否記住帳號
      if (state.loginData.remember) {
        localStorage.setItem("rem", 1);
      } else {
        localStorage.removeItem("rem");
      }
      // set cookie, redirect to overview
      cookies.set("token", data.result.token, midnight);
      router.push("/overview").catch((err) => console.log(err));
    } else {
      // 登入失敗
      swal.fire({
        title: "Failed...",
        text: `${data.response.msg}`,
        icon: "error",
        width: "20rem",
      });
    }
  },
  tokenTimeout: ({ dispatch }) => {
    swal.fire({
      title: "Oops...",
      text: "Token 過期或已從其他裝置登入",
      icon: "error",
      width: "20rem",
    });
    dispatch("logout");
  },
  logout: ({ dispatch }) => {
    cookies.remove("token");
    dispatch("resetAllData", null, { root: true });
    router.push("/login").catch((err) => console.log(err));
  },
};
const getters = {
  getField,
};
export default { namespaced, state, actions, mutations, getters };
